import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const removeTagFromReturn = {
  name: "removeTagFromReturn" as const,
  input: z.object({ returnId: zExt.objectId(), tagName: z.string() }),
  output: z.null(),
};
